export default __webpack_public_path__ + "static/media/030-verified.74d96919.png";